var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32109_128071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1836 0.0873241C8.62813 0.402626 7.39492 1.53937 6.99961 3.02876C6.92227 3.32746 6.90078 3.53075 6.88789 4.3439L6.86641 5.31055H5.7793C5.11328 5.31055 4.64062 5.32714 4.56758 5.35618C4.4 5.41426 4.21953 5.58851 4.16797 5.74201C4.11211 5.91211 2.96484 18.1881 2.96484 18.6113C2.96914 19.8393 3.88438 20.9263 5.13477 21.1793C5.58594 21.2706 16.4141 21.2706 16.8652 21.1793C17.6344 21.0217 18.425 20.4409 18.7473 19.7895C18.9449 19.3871 19.0352 19.0262 19.0352 18.5906C19.0352 18.2836 17.9094 6.13199 17.8535 5.83328C17.8234 5.66319 17.6301 5.43501 17.4625 5.36863C17.3508 5.32299 17.0629 5.31055 16.225 5.31055H15.1336L15.1121 4.3439C15.0906 3.29427 15.0477 3.04535 14.8199 2.49772C14.0938 0.73867 12.0957 -0.298506 10.1836 0.0873241ZM11.5801 1.39002C12.5254 1.58086 13.3418 2.31103 13.6426 3.23619C13.7027 3.41459 13.7242 3.66766 13.7371 4.38538L13.7586 5.31055H11.0043H8.25V4.50985C8.25 3.55979 8.30156 3.27768 8.55938 2.77983C9.10938 1.71777 10.3598 1.14524 11.5801 1.39002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32109_128071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21.2414,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.ab90d9e1.svg";
export { ForwardRef as ReactComponent };